import { render, staticRenderFns } from "./detailSaldo.vue?vue&type=template&id=25c28a37&scoped=true&"
import script from "./detailSaldo.js?vue&type=script&lang=js&"
export * from "./detailSaldo.js?vue&type=script&lang=js&"
import style0 from "./detailSaldo.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./detailSaldo.scss?vue&type=style&index=1&id=25c28a37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c28a37",
  null
  
)

export default component.exports